import { collectionRef } from "@/api/firebase/collectionOperations";
import { Profile, ProfileOnboarding } from "@/models/Profile.model";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { useState } from "react";
import { validateProfileOnboarding } from "../utils/profileValidation";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutes";

export const useUpdateProfile = () => {
  const profile = useCurrentUserProfile((s) => s.user);
  const setUserProfile = useCurrentUserProfile((s) => s.setUser);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const navigate = useNavigate();

  // Update profile function
  const updateProfile = async (values: Profile) => {
    const validation = validateProfileOnboarding(values);
    if (!validation.isValid) {
      setError(new Error(validation.error as string));
      return;
    }

    setLoading(true);
    try {
      const updatedProfile = { ...profile, ...values, onboarded: true };

      const profileRef = collectionRef.Profiles.doc(profile.uid);
      await profileRef.update(updatedProfile).then(() => {
        console.log("Profile updated successfully");
        setUserProfile(updatedProfile);
        setLoading(false);
        navigate(siteRoutes.profile.view.path);
      });
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  // This function is used to onboard the profile
  // It is similar to the updateProfile function but can be used for onboarding
  const onboardProfile = async (values: ProfileOnboarding) => {
    const validation = validateProfileOnboarding(values);
    if (!validation.isValid) {
      setError(new Error(validation.error as string));
      return;
    }

    setLoading(true);
    try {
      const updatedProfile = { ...profile, ...values, onboarded: true };

      const profileRef = collectionRef.Profiles.doc(profile.uid);
      await profileRef.update(updatedProfile).then(() => {
        console.log("Profile updated successfully");
        setUserProfile(updatedProfile);
        setLoading(false);
      });
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  return {
    onboardProfile,
    updateProfile,
    loading,
    error,
  };
};
